// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rwNvu","content":"styles_content__E9TLR","root":"styles_root__vUvq-"};